import moment from 'moment';
import _ from 'lodash';

// Transform all requests and responses
// to convert date values to and from UTC time
/** @ignore */
export function dateOffsetInterceptor() {
	'ngInject';
	return {
		request: config => {
			// SiteVisits metric uses the user's local time instead of UTC
			// Consider this a temporary solution to avoid changes to all other metrics
			// As we migrate to React we'll look for a permanent solution
			if (config.url !== '/api/v2/users/activity/SiteVisits') {
				mapToUtc(config.data);
				mapToUtc(config.params);
			}

			return config;
		},
		response: response => {
			if (response.config.url !== '/api/v2/users/activity/SiteVisits') {
				mapFromUtc(response.data);
			}

			return response;
		},
	};
}

// Check if the date is in one of the following formats:
// "2016-01-05T10:38:33.000+00:00"
// "2016-01-05T10:38:33+00:00"
// "2016-01-05T10:38:33.000Z"
// "2016-01-05T10:38:33Z"
// "2016-01-05 10:38:33"
const isDateFormat = str => {
	return /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}(\.\d{3})?([+-]\d{2}:\d{2}|Z)?$/.test(str);
};

// Check if the field name is a date field that the API uses:
// - ends with "_date" or "_at"
// - is "created" or "last_login" or "send_on" or "start" or "end"
// - starts with "date_"
const isDateField = fieldName => {
	return /(_date$|_at$|^created$|^last_login|^send_on$|^start$|^end$|^date_)/.test(fieldName);
};

// convert date string, Date object, or moment object to a string in the format
// "2016-01-05T10:38:33-07:00" for consumption by the server
// i.e. basically moment just adds the "T" in the middle and "-07:00" at the end
const toUtc = dateStr => {
	let dateObj = moment(dateStr);
	if (!dateObj.isValid()) {
		dateObj = moment();
	}
	return dateObj.format();
};

// recursively iterate an object or array
// and convert dates to UTC as needed (for the server)
const mapToUtc = objOrArray => {
	_.forEach(objOrArray, (value, key) => {
		if (typeof value == 'object') {
			// object or array
			mapToUtc(value);
		} else if (
			typeof value == 'string' &&
			isDateField(key) &&
			(value instanceof Date || isDateFormat(value) || value instanceof moment)
		) {
			objOrArray[key] = toUtc(value);
		}
	});
};

// convert dates from the server into iso8601 format such as
// "2016-01-05T10:38:33" for consumption by application
const fromUtc = dateStr => {
	let dateObj = moment.utc(dateStr);
	if (!dateObj.isValid()) {
		return dateStr;
	}
	return dateObj.local().format('YYYY-MM-DD\\THH:mm:ss');
};

// recursively iterate an object or array (from the server)
// and convert dates from UTC as needed
const mapFromUtc = objOrArray => {
	_.forEach(objOrArray, (value, key) => {
		if (typeof value == 'object') {
			// object or array
			mapFromUtc(value);
		} else if (typeof value == 'string' && isDateField(key) && isDateFormat(value)) {
			objOrArray[key] = fromUtc(value);
		}
	});
};
